import React from 'react';
import cn from 'classnames';
import { useTheme } from '@rescui/ui-contexts';
import styles from './separator.p.module.css.js';

var TabSeparator = function TabSeparator(_ref) {
  var className = _ref.className,
      themeFromProps = _ref.theme;
  var theme = useTheme(themeFromProps);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.separator, styles[theme], className)
  });
};

export { TabSeparator as default };
